import React from 'react'
import { Link } from 'react-router-dom'
import { Icon, Tooltip } from '@unbounded/unbounded-components'
import { ConsortiumsListItemFragment } from '~api/fragments/ConsortiumsListItem.generated'
import Tile from '~components/Tile'
import Image from '~components/Image'
import consortiumsIcon from '~assets/icons/consortiums.svg'
import Paths from '~routes/paths'

interface ComponentProps {
  consortium: ConsortiumsListItemFragment
}

const ConsortiumsListItem: React.FC<ComponentProps> = ({ consortium }) => {
  const { name, frameworks, description, logo, slug } = consortium
  const frameworkNames = frameworks.length ? frameworks.map(({ name: title }) => title).join(', ') : ''

  return (
    <Tile.Container $isLink={true} as={Link} to={`${Paths.consortiums}/${slug}`}>
      <Tooltip content={name}>
        <Tile.Header>
          <Tile.ImageContainer isBright={logo?.isBright}>
            <Image src={logo?.url} alt={name} />
          </Tile.ImageContainer>

          <Tile.Section>
            <Tile.Title>{name}</Tile.Title>

            {frameworkNames && (
              <Tile.SubHeader>
                <Icon src={consortiumsIcon} />
                <Tile.SubTitle>{frameworkNames}</Tile.SubTitle>
              </Tile.SubHeader>
            )}
          </Tile.Section>
        </Tile.Header>
      </Tooltip>

      <Tile.Section>
        <Tile.Description>{description || 'No description yet'}</Tile.Description>
      </Tile.Section>
    </Tile.Container>
  )
}

export default ConsortiumsListItem
